import { useEffect, useState } from "react";
import { getPrinter, getKitchenMode, getRole } from "@/pos/lib/printer";
import { bleStatus, bleReconnect, onBle, kitchenBle } from "@/pos/lib/ble";
import { api } from "@/pos/lib/api";

function probeSocket() {
  return new Promise((resolve) => {
    let done = false;
    const end = (ok) => { if (!done) { done = true; resolve(ok); } };
    try {
      const ws = new WebSocket("ws://127.0.0.1:40213/");
      ws.onopen = () => { ws.close(); end(true); };
      ws.onerror = () => end(false);
      setTimeout(() => { try { ws.close(); } catch (e) { /* abaikan */ } end(false); }, 1500);
    } catch (e) { end(false); }
  });
}

let lastBeat = 0;
function deviceId() {
  let id = localStorage.getItem("alfaz_device_id");
  if (!id) { id = `dev-${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`; localStorage.setItem("alfaz_device_id", id); }
  return id;
}
function deviceName() {
  const ua = navigator.userAgent;
  const os = /Android/i.test(ua) ? "Android" : /iPad|iPhone/i.test(ua) ? "iOS" : /Windows/i.test(ua) ? "Windows" : /Mac/i.test(ua) ? "Mac" : "Peranti";
  const br = /Edg/i.test(ua) ? "Edge" : /Chrome/i.test(ua) ? "Chrome" : /Safari/i.test(ua) ? "Safari" : /Firefox/i.test(ua) ? "Firefox" : "";
  return `${os} ${br}`.trim();
}
async function heartbeat(s, method, force) {
  if (!force && Date.now() - lastBeat < 15000) return;
  lastBeat = Date.now();
  const mode = getKitchenMode();
  const role = mode === "tablet" ? getRole() : "kaunter";
  let kitchen = {};
  if (mode === "same" && (localStorage.getItem("alfaz_ble_kitchen_id") || localStorage.getItem("alfaz_ble_kitchen_name"))) {
    await kitchenBle.reconnect();
    const k = kitchenBle.status();
    kitchen = { kitchen_ok: k.connected, kitchen_label: k.connected ? k.name || "Bersambung" : "Tidak bersambung" };
  }
  api.post("/printer-heartbeat", { device_id: deviceId(), device_name: deviceName(), method, ok: s.ok, label: s.label, role, ...kitchen }).catch(() => {});
}

// { ok, label } status printer tablet ini, dikemas kini setiap 20 saat.
export function usePrinterStatus() {
  const [st, setSt] = useState({ ok: false, label: "Menyemak..." });
  useEffect(() => {
    let alive = true;
    const check = async (ev) => {
      const m = getPrinter().method;
      let s;
      if (m === "browser") s = { ok: true, label: "Dialog pelayar" };
      else if (m === "direct") {
        await bleReconnect();
        const b = bleStatus();
        s = b.connected ? { ok: true, label: b.name || "Bersambung" } : { ok: false, label: "Tidak bersambung" };
      } else s = (await probeSocket()) ? { ok: true, label: "RawBT Server" } : { ok: false, label: "RawBT Server tiada" };
      if (alive) setSt(s);
      heartbeat(s, m, ev === true);
    };
    check();
    const t = setInterval(check, 20000);
    const onChange = () => check(true);
    const off = onBle(onChange);
    window.addEventListener("printer-changed", onChange);
    return () => { alive = false; clearInterval(t); off(); window.removeEventListener("printer-changed", onChange); };
  }, []);
  return st;
}
